import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import * as React from 'react';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { IIconProps } from '@fluentui/react/lib/Icon';
import { OfficeApp } from 'owa-left-rail-utils';
import { getPaletteAsRawColors } from 'owa-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { observer } from 'mobx-react-lite';
import { Module } from 'owa-bootstrap';

let styles = require('./LeftRailItem.scss');
let classNames = require('classnames/bind').bind(styles);

export interface LeftRailItemProps extends React.HTMLAttributes<HTMLAnchorElement> {
    iconProps: IIconProps;
    item: OfficeApp | Module;
    isSelected: boolean;
    text: string;
    isHorizontal: boolean;
    href: string;
    onClick: () => void;
    disabled: boolean;
    openInNewTab?: boolean;
}

export default observer(function LeftRailItem(props: LeftRailItemProps) {
    const {
        iconProps,
        item,
        text,
        isSelected,
        isHorizontal,
        href,
        onClick,
        disabled,
        openInNewTab,
    } = props;
    const itemAriaProps: AriaProperties = {
        role: AriaRoles.menuitem,
        label: text,
    };
    const palette = getPaletteAsRawColors();

    const keyDownHandler = (e: React.KeyboardEvent<HTMLElement>): void => {
        if (e.key == 'Spacebar' || e.key == ' ') {
            e.stopPropagation();
            if (openInNewTab) {
                window.open(href);
            } else {
                window.location.href = href;
            }
            onClick();
        }
    };

    return (
        <CommandBarButton
            key={item}
            styles={{
                root: classNames(
                    isHorizontal ? styles.root : styles.verRoot,
                    isFeatureEnabled('tri-metaOsRail') && styles.metaOsHoverBg
                ),
                icon: {
                    color: isSelected ? palette.themePrimary : palette.neutralSecondary,
                },
                iconHovered: {
                    color: isSelected ? palette.themePrimary : palette.neutralSecondary,
                },
                iconPressed: {
                    color: isSelected ? palette.themePrimary : palette.neutralSecondary,
                },
                flexContainer:
                    isSelected &&
                    isFeatureEnabled('tri-metaOsRail') &&
                    styles.selectedFlexContainer,
            }}
            iconProps={iconProps}
            data-is-focusable={true}
            data-workload={item}
            onClick={onClick}
            title={text}
            onKeyDown={keyDownHandler}
            href={href}
            target={openInNewTab ? '_blank' : null}
            {...generateDomPropertiesForAria(itemAriaProps)}
            disabled={disabled}
        />
    );
});
